module.exports = __webpack_public_path__ + "static/media/merriweather-light-webfont.f423e689.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather-light-webfont.eot
// module id = 282
// module chunks = 0